// Traductions Postinity — onglet « Ma cérémonie » (+ éléments partagés).
const fr = {
  cer_step_word: "Mot", cer_step_songs: "Chansons", cer_step_photos: "Photos", cer_step_video: "Vidéo", cer_step_file: "Fichier",
  cer_intro: "Préparez sereinement votre cérémonie et votre départ, à votre rythme : vos mots, vos chansons, vos photos et une vidéo. C'est 100 % gratuit — rien d'autre à gérer.",
  cer_msg_label: "Message pour la cérémonie (optionnel)",
  cer_msg_placeholder: "Quelques mots pour accompagner votre cérémonie…",
  cer_msg_off: "Vous avez choisi de ne pas laisser de message écrit.",
  cer_songs_label: "Titres de chanson", cer_songs_placeholder: "Ex. Jacques Brel — Ne me quitte pas",
  save: "Enregistrer", add: "Ajouter", view: "Visionner", cancel: "Annuler", start: "Démarrer", stop: "Arrêter", remaining: "restant",
  cer_photos_label: "Photos de la cérémonie", cer_photos_off: "Vous avez choisi de ne pas ajouter de photos.",
  drag_hint: "Glissez les photos pour changer l'ordre", see_slideshow: "Voir le diaporama",
  cer_video_label: "Vidéo de la cérémonie", video_max: "Durée max : 2 min", cer_video_off: "Vous avez choisi de ne pas ajouter de vidéo.",
  import_video: "Importer une vidéo", sending: "Envoi", record_camera: "Enregistrer avec ma caméra", ready_max2: "Prêt ? Durée max : 2 min",
  sending_video: "Envoi de la vidéo…", video_saved: "Vidéo enregistrée", view_my_video: "Visionner ma vidéo", delete_video: "Supprimer la vidéo",
  del_video_confirm: "Êtes-vous sûr ? Cette vidéo sera définitivement supprimée. Confirmez une deuxième fois.", yes_delete: "Oui, supprimer définitivement",
  file_label: "Fichier (PDF ou autre)", file_max: "Max 50 Mo", add_file: "Ajouter un fichier", sending_short: "Envoi…", file_off: "Vous avez choisi de ne pas ajouter de fichier.",
  cgu_footer_1: "En utilisant cet espace, vous acceptez nos", cgu_link: "Conditions Générales d'Utilisation (CGU)",
  step_missing: "Il manque encore quelques informations",
  step_alldone: "Tout est complété",
  yes: "OUI",
  no: "NON",
  music_title: "Son du diaporama",
  music_on: "Activé",
  music_off: "Coupé",
  music_help: "Choisissez une musique de la bibliothèque ou importez la vôtre (MP3 ou MP4, max 20 Mo). Elle est enregistrée automatiquement.",
  my_music: "Ma musique",
  save_choice: "Enregistrer mon choix",
  replace_music: "Remplacer ma musique",
  import_music: "Importer ma musique",
  delete_music: "Supprimer ma musique",
  music_file_default: "musique",
  music_saved: "Musique enregistrée ✓",
};
const en = {
  cer_step_word: "Words", cer_step_songs: "Songs", cer_step_photos: "Photos", cer_step_video: "Video", cer_step_file: "File",
  cer_intro: "Prepare your ceremony and your departure calmly, at your own pace: your words, your songs, your photos and a video. It's 100% free — nothing else to handle.",
  cer_msg_label: "Message for the ceremony (optional)",
  cer_msg_placeholder: "A few words to accompany your ceremony…",
  cer_msg_off: "You chose not to leave a written message.",
  cer_songs_label: "Song titles", cer_songs_placeholder: "e.g. Jacques Brel — Ne me quitte pas",
  save: "Save", add: "Add", view: "Watch", cancel: "Cancel", start: "Start", stop: "Stop", remaining: "left",
  cer_photos_label: "Ceremony photos", cer_photos_off: "You chose not to add photos.",
  drag_hint: "Drag photos to reorder", see_slideshow: "View slideshow",
  cer_video_label: "Ceremony video", video_max: "Max length: 2 min", cer_video_off: "You chose not to add a video.",
  import_video: "Import a video", sending: "Uploading", record_camera: "Record with my camera", ready_max2: "Ready? Max length: 2 min",
  sending_video: "Uploading the video…", video_saved: "Video saved", view_my_video: "Watch my video", delete_video: "Delete the video",
  del_video_confirm: "Are you sure? This video will be permanently deleted. Confirm a second time.", yes_delete: "Yes, delete permanently",
  file_label: "File (PDF or other)", file_max: "Max 50 MB", add_file: "Add a file", sending_short: "Uploading…", file_off: "You chose not to add a file.",
  cgu_footer_1: "By using this space, you accept our", cgu_link: "Terms of Use (Terms)",
  step_missing: "Some information is still missing",
  step_alldone: "Everything is complete",
  yes: "YES",
  no: "NO",
  music_title: "Slideshow sound",
  music_on: "On",
  music_off: "Off",
  music_help: "Choose music from the library or import your own (MP3 or MP4, max 20 MB). It is saved automatically.",
  my_music: "My music",
  save_choice: "Save my choice",
  replace_music: "Replace my music",
  import_music: "Import my music",
  delete_music: "Delete my music",
  music_file_default: "music",
  music_saved: "Music saved ✓",
};
const es = {
  cer_step_word: "Palabras", cer_step_songs: "Canciones", cer_step_photos: "Fotos", cer_step_video: "Vídeo", cer_step_file: "Archivo",
  cer_intro: "Prepara tu ceremonia y tu partida con calma, a tu ritmo: tus palabras, tus canciones, tus fotos y un vídeo. Es 100 % gratis — nada más que gestionar.",
  cer_msg_label: "Mensaje para la ceremonia (opcional)",
  cer_msg_placeholder: "Unas palabras para acompañar tu ceremonia…",
  cer_msg_off: "Elegiste no dejar un mensaje escrito.",
  cer_songs_label: "Títulos de canciones", cer_songs_placeholder: "Ej. Jacques Brel — Ne me quitte pas",
  save: "Guardar", add: "Añadir", view: "Ver", cancel: "Cancelar", start: "Empezar", stop: "Detener", remaining: "restante",
  cer_photos_label: "Fotos de la ceremonia", cer_photos_off: "Elegiste no añadir fotos.",
  drag_hint: "Arrastra las fotos para reordenar", see_slideshow: "Ver el pase de diapositivas",
  cer_video_label: "Vídeo de la ceremonia", video_max: "Duración máx.: 2 min", cer_video_off: "Elegiste no añadir un vídeo.",
  import_video: "Importar un vídeo", sending: "Enviando", record_camera: "Grabar con mi cámara", ready_max2: "¿Listo? Duración máx.: 2 min",
  sending_video: "Enviando el vídeo…", video_saved: "Vídeo guardado", view_my_video: "Ver mi vídeo", delete_video: "Eliminar el vídeo",
  del_video_confirm: "¿Estás seguro? Este vídeo se eliminará definitivamente. Confirma una segunda vez.", yes_delete: "Sí, eliminar definitivamente",
  file_label: "Archivo (PDF u otro)", file_max: "Máx. 50 MB", add_file: "Añadir un archivo", sending_short: "Enviando…", file_off: "Elegiste no añadir un archivo.",
  cgu_footer_1: "Al usar este espacio, aceptas nuestras", cgu_link: "Condiciones de Uso (CGU)",
  step_missing: "Aún falta información",
  step_alldone: "Todo está completo",
  yes: "SÍ",
  no: "NO",
  music_title: "Sonido de la presentación",
  music_on: "Activado",
  music_off: "Silenciado",
  music_help: "Elige música de la biblioteca o importa la tuya (MP3 o MP4, máx. 20 MB). Se guarda automáticamente.",
  my_music: "Mi música",
  save_choice: "Guardar mi elección",
  replace_music: "Reemplazar mi música",
  import_music: "Importar mi música",
  delete_music: "Eliminar mi música",
  music_file_default: "música",
  music_saved: "Música guardada ✓",
};
const de = {
  cer_step_word: "Worte", cer_step_songs: "Lieder", cer_step_photos: "Fotos", cer_step_video: "Video", cer_step_file: "Datei",
  cer_intro: "Bereiten Sie Ihre Zeremonie und Ihren Abschied in Ruhe vor, in Ihrem Tempo: Ihre Worte, Ihre Lieder, Ihre Fotos und ein Video. Es ist 100 % kostenlos — nichts weiter zu regeln.",
  cer_msg_label: "Nachricht für die Zeremonie (optional)",
  cer_msg_placeholder: "Ein paar Worte zur Begleitung Ihrer Zeremonie…",
  cer_msg_off: "Sie haben sich entschieden, keine schriftliche Nachricht zu hinterlassen.",
  cer_songs_label: "Liedtitel", cer_songs_placeholder: "z. B. Jacques Brel — Ne me quitte pas",
  save: "Speichern", add: "Hinzufügen", view: "Ansehen", cancel: "Abbrechen", start: "Starten", stop: "Stoppen", remaining: "übrig",
  cer_photos_label: "Fotos der Zeremonie", cer_photos_off: "Sie haben sich entschieden, keine Fotos hinzuzufügen.",
  drag_hint: "Fotos ziehen, um die Reihenfolge zu ändern", see_slideshow: "Diashow ansehen",
  cer_video_label: "Video der Zeremonie", video_max: "Max. Dauer: 2 Min.", cer_video_off: "Sie haben sich entschieden, kein Video hinzuzufügen.",
  import_video: "Video importieren", sending: "Wird hochgeladen", record_camera: "Mit meiner Kamera aufnehmen", ready_max2: "Bereit? Max. Dauer: 2 Min.",
  sending_video: "Video wird hochgeladen…", video_saved: "Video gespeichert", view_my_video: "Mein Video ansehen", delete_video: "Video löschen",
  del_video_confirm: "Sind Sie sicher? Dieses Video wird endgültig gelöscht. Bestätigen Sie ein zweites Mal.", yes_delete: "Ja, endgültig löschen",
  file_label: "Datei (PDF oder andere)", file_max: "Max. 50 MB", add_file: "Datei hinzufügen", sending_short: "Wird hochgeladen…", file_off: "Sie haben sich entschieden, keine Datei hinzuzufügen.",
  cgu_footer_1: "Mit der Nutzung dieses Bereichs akzeptieren Sie unsere", cgu_link: "Nutzungsbedingungen (AGB)",
  step_missing: "Es fehlen noch einige Informationen",
  step_alldone: "Alles ist vollständig",
  yes: "JA",
  no: "NEIN",
  music_title: "Ton der Diashow",
  music_on: "An",
  music_off: "Aus",
  music_help: "Wählen Sie Musik aus der Bibliothek oder importieren Sie Ihre eigene (MP3 oder MP4, max. 20 MB). Sie wird automatisch gespeichert.",
  my_music: "Meine Musik",
  save_choice: "Meine Auswahl speichern",
  replace_music: "Meine Musik ersetzen",
  import_music: "Meine Musik importieren",
  delete_music: "Meine Musik löschen",
  music_file_default: "Musik",
  music_saved: "Musik gespeichert ✓",
};
const it = {
  cer_step_word: "Parole", cer_step_songs: "Canzoni", cer_step_photos: "Foto", cer_step_video: "Video", cer_step_file: "File",
  cer_intro: "Prepara la tua cerimonia e la tua partenza con serenità, al tuo ritmo: le tue parole, le tue canzoni, le tue foto e un video. È 100% gratis — nient'altro da gestire.",
  cer_msg_label: "Messaggio per la cerimonia (facoltativo)",
  cer_msg_placeholder: "Qualche parola per accompagnare la tua cerimonia…",
  cer_msg_off: "Hai scelto di non lasciare un messaggio scritto.",
  cer_songs_label: "Titoli delle canzoni", cer_songs_placeholder: "Es. Jacques Brel — Ne me quitte pas",
  save: "Salva", add: "Aggiungi", view: "Guarda", cancel: "Annulla", start: "Avvia", stop: "Ferma", remaining: "rimasto",
  cer_photos_label: "Foto della cerimonia", cer_photos_off: "Hai scelto di non aggiungere foto.",
  drag_hint: "Trascina le foto per riordinarle", see_slideshow: "Vedi la presentazione",
  cer_video_label: "Video della cerimonia", video_max: "Durata max: 2 min", cer_video_off: "Hai scelto di non aggiungere un video.",
  import_video: "Importa un video", sending: "Invio", record_camera: "Registra con la mia fotocamera", ready_max2: "Pronto? Durata max: 2 min",
  sending_video: "Invio del video…", video_saved: "Video salvato", view_my_video: "Guarda il mio video", delete_video: "Elimina il video",
  del_video_confirm: "Sei sicuro? Questo video sarà eliminato definitivamente. Conferma una seconda volta.", yes_delete: "Sì, elimina definitivamente",
  file_label: "File (PDF o altro)", file_max: "Max 50 MB", add_file: "Aggiungi un file", sending_short: "Invio…", file_off: "Hai scelto di non aggiungere un file.",
  cgu_footer_1: "Utilizzando questo spazio, accetti le nostre", cgu_link: "Condizioni d'Uso (CGU)",
  step_missing: "Mancano ancora alcune informazioni",
  step_alldone: "Tutto è completo",
  yes: "SÌ",
  no: "NO",
  music_title: "Audio della presentazione",
  music_on: "Attivo",
  music_off: "Disattivato",
  music_help: "Scegli una musica dalla libreria o importa la tua (MP3 o MP4, max 20 MB). Viene salvata automaticamente.",
  my_music: "La mia musica",
  save_choice: "Salva la mia scelta",
  replace_music: "Sostituisci la mia musica",
  import_music: "Importa la mia musica",
  delete_music: "Elimina la mia musica",
  music_file_default: "musica",
  music_saved: "Musica salvata ✓",
};
const pl = {
  cer_step_word: "Słowa", cer_step_songs: "Piosenki", cer_step_photos: "Zdjęcia", cer_step_video: "Wideo", cer_step_file: "Plik",
  cer_intro: "Przygotuj ceremonię i swoje odejście spokojnie, we własnym tempie: twoje słowa, piosenki, zdjęcia i wideo. Jest w 100% za darmo — nic więcej do ogarniania.",
  cer_msg_label: "Wiadomość na ceremonię (opcjonalnie)",
  cer_msg_placeholder: "Kilka słów, aby towarzyszyć Twojej ceremonii…",
  cer_msg_off: "Wybrałeś, aby nie zostawiać pisemnej wiadomości.",
  cer_songs_label: "Tytuły piosenek", cer_songs_placeholder: "Np. Jacques Brel — Ne me quitte pas",
  save: "Zapisz", add: "Dodaj", view: "Obejrzyj", cancel: "Anuluj", start: "Rozpocznij", stop: "Zatrzymaj", remaining: "pozostało",
  cer_photos_label: "Zdjęcia z ceremonii", cer_photos_off: "Wybrałeś, aby nie dodawać zdjęć.",
  drag_hint: "Przeciągnij zdjęcia, aby zmienić kolejność", see_slideshow: "Zobacz pokaz slajdów",
  cer_video_label: "Wideo z ceremonii", video_max: "Maks. czas: 2 min", cer_video_off: "Wybrałeś, aby nie dodawać wideo.",
  import_video: "Zaimportuj wideo", sending: "Wysyłanie", record_camera: "Nagraj kamerą", ready_max2: "Gotowy? Maks. czas: 2 min",
  sending_video: "Wysyłanie wideo…", video_saved: "Wideo zapisane", view_my_video: "Obejrzyj moje wideo", delete_video: "Usuń wideo",
  del_video_confirm: "Na pewno? To wideo zostanie trwale usunięte. Potwierdź drugi raz.", yes_delete: "Tak, usuń trwale",
  file_label: "Plik (PDF lub inny)", file_max: "Maks. 50 MB", add_file: "Dodaj plik", sending_short: "Wysyłanie…", file_off: "Wybrałeś, aby nie dodawać pliku.",
  cgu_footer_1: "Korzystając z tej przestrzeni, akceptujesz nasze", cgu_link: "Warunki Użytkowania (Regulamin)",
  step_missing: "Wciąż brakuje niektórych informacji",
  step_alldone: "Wszystko uzupełnione",
  yes: "TAK",
  no: "NIE",
  music_title: "Dźwięk pokazu slajdów",
  music_on: "Włączony",
  music_off: "Wyłączony",
  music_help: "Wybierz muzykę z biblioteki lub zaimportuj własną (MP3 lub MP4, maks. 20 MB). Zapisuje się automatycznie.",
  my_music: "Moja muzyka",
  save_choice: "Zapisz mój wybór",
  replace_music: "Zamień moją muzykę",
  import_music: "Zaimportuj moją muzykę",
  delete_music: "Usuń moją muzykę",
  music_file_default: "muzyka",
  music_saved: "Muzyka zapisana ✓",
};
const fil = {
  cer_step_word: "Mga salita", cer_step_songs: "Mga kanta", cer_step_photos: "Mga larawan", cer_step_video: "Video", cer_step_file: "File",
  cer_intro: "Ihanda nang mahinahon ang iyong seremonya at pag-alis, sa sarili mong bilis: ang iyong mga salita, kanta, larawan at isang video. 100% libre ito — wala nang iba pang aasikasuhin.",
  cer_msg_label: "Mensahe para sa seremonya (opsyonal)",
  cer_msg_placeholder: "Ilang salita para samahan ang iyong seremonya…",
  cer_msg_off: "Pinili mong huwag mag-iwan ng nakasulat na mensahe.",
  cer_songs_label: "Mga pamagat ng kanta", cer_songs_placeholder: "Hal. Jacques Brel — Ne me quitte pas",
  save: "I-save", add: "Idagdag", view: "Panoorin", cancel: "Kanselahin", start: "Simulan", stop: "Itigil", remaining: "natitira",
  cer_photos_label: "Mga larawan ng seremonya", cer_photos_off: "Pinili mong huwag magdagdag ng larawan.",
  drag_hint: "I-drag ang mga larawan para baguhin ang pagkakasunod", see_slideshow: "Tingnan ang slideshow",
  cer_video_label: "Video ng seremonya", video_max: "Max na haba: 2 min", cer_video_off: "Pinili mong huwag magdagdag ng video.",
  import_video: "Mag-import ng video", sending: "Ina-upload", record_camera: "Mag-record gamit ang camera", ready_max2: "Handa na? Max na haba: 2 min",
  sending_video: "Ina-upload ang video…", video_saved: "Na-save ang video", view_my_video: "Panoorin ang aking video", delete_video: "Burahin ang video",
  del_video_confirm: "Sigurado ka? Permanenteng buburahin ang video na ito. Kumpirmahin muli.", yes_delete: "Oo, permanenteng burahin",
  file_label: "File (PDF o iba pa)", file_max: "Max 50 MB", add_file: "Magdagdag ng file", sending_short: "Ina-upload…", file_off: "Pinili mong huwag magdagdag ng file.",
  cgu_footer_1: "Sa paggamit ng espasyong ito, tinatanggap mo ang aming", cgu_link: "Mga Tuntunin ng Paggamit (Terms)",
  step_missing: "May kulang pang impormasyon",
  step_alldone: "Kumpleto na ang lahat",
  yes: "OO",
  no: "HINDI",
  music_title: "Tunog ng slideshow",
  music_on: "Naka-on",
  music_off: "Naka-off",
  music_help: "Pumili ng musika mula sa library o mag-import ng sarili mo (MP3 o MP4, max 20 MB). Awtomatiko itong nase-save.",
  my_music: "Aking musika",
  save_choice: "I-save ang aking pinili",
  replace_music: "Palitan ang aking musika",
  import_music: "Mag-import ng musika",
  delete_music: "Burahin ang aking musika",
  music_file_default: "musika",
  music_saved: "Na-save ang musika ✓",
};
const ru = {
  cer_step_word: "Слова", cer_step_songs: "Песни", cer_step_photos: "Фото", cer_step_video: "Видео", cer_step_file: "Файл",
  cer_intro: "Спокойно подготовьте свою церемонию и уход, в своём темпе: ваши слова, песни, фото и видео. Это на 100% бесплатно — больше ничем не нужно заниматься.",
  cer_msg_label: "Сообщение для церемонии (необязательно)",
  cer_msg_placeholder: "Несколько слов, чтобы сопроводить вашу церемонию…",
  cer_msg_off: "Вы решили не оставлять письменное сообщение.",
  cer_songs_label: "Названия песен", cer_songs_placeholder: "Напр. Jacques Brel — Ne me quitte pas",
  save: "Сохранить", add: "Добавить", view: "Смотреть", cancel: "Отмена", start: "Начать", stop: "Остановить", remaining: "осталось",
  cer_photos_label: "Фото церемонии", cer_photos_off: "Вы решили не добавлять фото.",
  drag_hint: "Перетащите фото, чтобы изменить порядок", see_slideshow: "Смотреть слайд-шоу",
  cer_video_label: "Видео церемонии", video_max: "Макс. длительность: 2 мин", cer_video_off: "Вы решили не добавлять видео.",
  import_video: "Импортировать видео", sending: "Загрузка", record_camera: "Записать камерой", ready_max2: "Готовы? Макс. длительность: 2 мин",
  sending_video: "Загрузка видео…", video_saved: "Видео сохранено", view_my_video: "Смотреть моё видео", delete_video: "Удалить видео",
  del_video_confirm: "Вы уверены? Это видео будет удалено навсегда. Подтвердите второй раз.", yes_delete: "Да, удалить навсегда",
  file_label: "Файл (PDF или другой)", file_max: "Макс. 50 МБ", add_file: "Добавить файл", sending_short: "Загрузка…", file_off: "Вы решили не добавлять файл.",
  cgu_footer_1: "Используя это пространство, вы принимаете наши", cgu_link: "Условия использования",
  step_missing: "Ещё не хватает некоторых данных",
  step_alldone: "Всё заполнено",
  yes: "ДА",
  no: "НЕТ",
  music_title: "Звук слайд-шоу",
  music_on: "Включён",
  music_off: "Выключен",
  music_help: "Выберите музыку из библиотеки или импортируйте свою (MP3 или MP4, макс. 20 МБ). Она сохраняется автоматически.",
  my_music: "Моя музыка",
  save_choice: "Сохранить выбор",
  replace_music: "Заменить музыку",
  import_music: "Импортировать музыку",
  delete_music: "Удалить музыку",
  music_file_default: "музыка",
  music_saved: "Музыка сохранена ✓",
};
const el = {
  cer_step_word: "Λόγια", cer_step_songs: "Τραγούδια", cer_step_photos: "Φωτογραφίες", cer_step_video: "Βίντεο", cer_step_file: "Αρχείο",
  cer_intro: "Ετοιμάστε ήρεμα την τελετή σας και την αναχώρησή σας, με τον ρυθμό σας: τα λόγια σας, τα τραγούδια σας, οι φωτογραφίες σας και ένα βίντεο. Είναι 100% δωρεάν — τίποτα άλλο να διαχειριστείτε.",
  cer_msg_label: "Μήνυμα για την τελετή (προαιρετικό)",
  cer_msg_placeholder: "Λίγα λόγια για να συνοδεύσουν την τελετή σας…",
  cer_msg_off: "Επιλέξατε να μην αφήσετε γραπτό μήνυμα.",
  cer_songs_label: "Τίτλοι τραγουδιών", cer_songs_placeholder: "Π.χ. Jacques Brel — Ne me quitte pas",
  save: "Αποθήκευση", add: "Προσθήκη", view: "Προβολή", cancel: "Άκυρο", start: "Έναρξη", stop: "Διακοπή", remaining: "απομένουν",
  cer_photos_label: "Φωτογραφίες τελετής", cer_photos_off: "Επιλέξατε να μην προσθέσετε φωτογραφίες.",
  drag_hint: "Σύρετε τις φωτογραφίες για αναδιάταξη", see_slideshow: "Δείτε την παρουσίαση",
  cer_video_label: "Βίντεο τελετής", video_max: "Μέγ. διάρκεια: 2 λεπτά", cer_video_off: "Επιλέξατε να μην προσθέσετε βίντεο.",
  import_video: "Εισαγωγή βίντεο", sending: "Μεταφόρτωση", record_camera: "Εγγραφή με την κάμερά μου", ready_max2: "Έτοιμοι; Μέγ. διάρκεια: 2 λεπτά",
  sending_video: "Μεταφόρτωση βίντεο…", video_saved: "Το βίντεο αποθηκεύτηκε", view_my_video: "Δείτε το βίντεό μου", delete_video: "Διαγραφή βίντεο",
  del_video_confirm: "Είστε σίγουροι; Αυτό το βίντεο θα διαγραφεί οριστικά. Επιβεβαιώστε δεύτερη φορά.", yes_delete: "Ναι, οριστική διαγραφή",
  file_label: "Αρχείο (PDF ή άλλο)", file_max: "Μέγ. 50 MB", add_file: "Προσθήκη αρχείου", sending_short: "Μεταφόρτωση…", file_off: "Επιλέξατε να μην προσθέσετε αρχείο.",
  cgu_footer_1: "Χρησιμοποιώντας αυτόν τον χώρο, αποδέχεστε τους", cgu_link: "Όρους Χρήσης",
  step_missing: "Λείπουν ακόμη ορισμένες πληροφορίες",
  step_alldone: "Όλα ολοκληρώθηκαν",
  yes: "ΝΑΙ",
  no: "ΟΧΙ",
  music_title: "Ήχος παρουσίασης",
  music_on: "Ενεργό",
  music_off: "Ανενεργό",
  music_help: "Επιλέξτε μουσική από τη βιβλιοθήκη ή εισαγάγετε τη δική σας (MP3 ή MP4, μέγ. 20 MB). Αποθηκεύεται αυτόματα.",
  my_music: "Η μουσική μου",
  save_choice: "Αποθήκευση επιλογής",
  replace_music: "Αντικατάσταση μουσικής",
  import_music: "Εισαγωγή μουσικής",
  delete_music: "Διαγραφή μουσικής",
  music_file_default: "μουσική",
  music_saved: "Η μουσική αποθηκεύτηκε ✓",
};
const hi = {
  cer_step_word: "शब्द", cer_step_songs: "गीत", cer_step_photos: "तस्वीरें", cer_step_video: "वीडियो", cer_step_file: "फ़ाइल",
  cer_intro: "अपनी गति से शांति से अपना समारोह और विदाई तैयार करें: आपके शब्द, गीत, तस्वीरें और एक वीडियो। यह 100% मुफ़्त है — और कुछ संभालने की ज़रूरत नहीं।",
  cer_msg_label: "समारोह के लिए संदेश (वैकल्पिक)",
  cer_msg_placeholder: "आपके समारोह के साथ कुछ शब्द…",
  cer_msg_off: "आपने लिखित संदेश न छोड़ने का चुनाव किया।",
  cer_songs_label: "गीतों के शीर्षक", cer_songs_placeholder: "उदा. Jacques Brel — Ne me quitte pas",
  save: "सहेजें", add: "जोड़ें", view: "देखें", cancel: "रद्द करें", start: "शुरू करें", stop: "रोकें", remaining: "शेष",
  cer_photos_label: "समारोह की तस्वीरें", cer_photos_off: "आपने तस्वीरें न जोड़ने का चुनाव किया।",
  drag_hint: "क्रम बदलने के लिए तस्वीरें खींचें", see_slideshow: "स्लाइडशो देखें",
  cer_video_label: "समारोह का वीडियो", video_max: "अधिकतम अवधि: 2 मिनट", cer_video_off: "आपने वीडियो न जोड़ने का चुनाव किया।",
  import_video: "वीडियो आयात करें", sending: "अपलोड हो रहा", record_camera: "मेरे कैमरे से रिकॉर्ड करें", ready_max2: "तैयार? अधिकतम अवधि: 2 मिनट",
  sending_video: "वीडियो अपलोड हो रहा…", video_saved: "वीडियो सहेजा गया", view_my_video: "मेरा वीडियो देखें", delete_video: "वीडियो हटाएँ",
  del_video_confirm: "क्या आप निश्चित हैं? यह वीडियो स्थायी रूप से हटा दिया जाएगा। दूसरी बार पुष्टि करें।", yes_delete: "हाँ, स्थायी रूप से हटाएँ",
  file_label: "फ़ाइल (PDF या अन्य)", file_max: "अधिकतम 50 MB", add_file: "फ़ाइल जोड़ें", sending_short: "अपलोड हो रहा…", file_off: "आपने फ़ाइल न जोड़ने का चुनाव किया।",
  cgu_footer_1: "इस स्थान का उपयोग करके, आप हमारी", cgu_link: "उपयोग की शर्तें (CGU) स्वीकार करते हैं",
  step_missing: "कुछ जानकारी अभी भी बाकी है",
  step_alldone: "सब कुछ पूरा है",
  yes: "हाँ",
  no: "नहीं",
  music_title: "स्लाइडशो की ध्वनि",
  music_on: "चालू",
  music_off: "बंद",
  music_help: "लाइब्रेरी से संगीत चुनें या अपना आयात करें (MP3 या MP4, अधिकतम 20 MB)। यह स्वतः सहेजा जाता है।",
  my_music: "मेरा संगीत",
  save_choice: "मेरा चुनाव सहेजें",
  replace_music: "मेरा संगीत बदलें",
  import_music: "मेरा संगीत आयात करें",
  delete_music: "मेरा संगीत हटाएँ",
  music_file_default: "संगीत",
  music_saved: "संगीत सहेजा गया ✓",
};
const ja = {
  cer_step_word: "言葉", cer_step_songs: "曲", cer_step_photos: "写真", cer_step_video: "動画", cer_step_file: "ファイル",
  cer_intro: "ご自分のペースで、落ち着いてセレモニーと旅立ちを準備しましょう：あなたの言葉、曲、写真、そして動画。100% 無料です — ほかに手間はありません。",
  cer_msg_label: "セレモニーへのメッセージ（任意）",
  cer_msg_placeholder: "セレモニーに添えるひと言を…",
  cer_msg_off: "書面のメッセージを残さないことを選びました。",
  cer_songs_label: "曲のタイトル", cer_songs_placeholder: "例：Jacques Brel — Ne me quitte pas",
  save: "保存", add: "追加", view: "見る", cancel: "キャンセル", start: "開始", stop: "停止", remaining: "残り",
  cer_photos_label: "セレモニーの写真", cer_photos_off: "写真を追加しないことを選びました。",
  drag_hint: "写真をドラッグして順序を変更", see_slideshow: "スライドショーを見る",
  cer_video_label: "セレモニーの動画", video_max: "最大長：2分", cer_video_off: "動画を追加しないことを選びました。",
  import_video: "動画を読み込む", sending: "アップロード中", record_camera: "カメラで録画", ready_max2: "準備はいいですか？最大長：2分",
  sending_video: "動画をアップロード中…", video_saved: "動画を保存しました", view_my_video: "自分の動画を見る", delete_video: "動画を削除",
  del_video_confirm: "よろしいですか？この動画は完全に削除されます。もう一度確認してください。", yes_delete: "はい、完全に削除する",
  file_label: "ファイル（PDF ほか）", file_max: "最大 50 MB", add_file: "ファイルを追加", sending_short: "アップロード中…", file_off: "ファイルを追加しないことを選びました。",
  cgu_footer_1: "この空間を利用することで、あなたは当社の", cgu_link: "利用規約に同意します",
  step_missing: "まだ入力が足りません",
  step_alldone: "すべて完了しました",
  yes: "はい",
  no: "いいえ",
  music_title: "スライドショーの音",
  music_on: "オン",
  music_off: "オフ",
  music_help: "ライブラリから音楽を選ぶか、自分の音楽を読み込みます（MP3 または MP4、最大 20 MB）。自動的に保存されます。",
  my_music: "自分の音楽",
  save_choice: "選択を保存",
  replace_music: "音楽を差し替える",
  import_music: "音楽を読み込む",
  delete_music: "音楽を削除",
  music_file_default: "音楽",
  music_saved: "音楽を保存しました ✓",
};
const zh = {
  cer_step_word: "文字", cer_step_songs: "歌曲", cer_step_photos: "照片", cer_step_video: "视频", cer_step_file: "文件",
  cer_intro: "按自己的节奏，安心准备您的仪式与告别：您的文字、歌曲、照片和一段视频。完全免费 —— 无需操心其他。",
  cer_msg_label: "写给仪式的留言（可选）",
  cer_msg_placeholder: "为您的仪式写几句话…",
  cer_msg_off: "您选择不留下书面留言。",
  cer_songs_label: "歌曲名称", cer_songs_placeholder: "例如：Jacques Brel — Ne me quitte pas",
  save: "保存", add: "添加", view: "观看", cancel: "取消", start: "开始", stop: "停止", remaining: "剩余",
  cer_photos_label: "仪式照片", cer_photos_off: "您选择不添加照片。",
  drag_hint: "拖动照片以调整顺序", see_slideshow: "查看幻灯片",
  cer_video_label: "仪式视频", video_max: "最长：2 分钟", cer_video_off: "您选择不添加视频。",
  import_video: "导入视频", sending: "上传中", record_camera: "用我的摄像头录制", ready_max2: "准备好了吗？最长：2 分钟",
  sending_video: "正在上传视频…", video_saved: "视频已保存", view_my_video: "观看我的视频", delete_video: "删除视频",
  del_video_confirm: "确定吗？此视频将被永久删除。请再次确认。", yes_delete: "是的，永久删除",
  file_label: "文件（PDF 或其他）", file_max: "最大 50 MB", add_file: "添加文件", sending_short: "上传中…", file_off: "您选择不添加文件。",
  cgu_footer_1: "使用此空间即表示您接受我们的", cgu_link: "使用条款（CGU）",
  step_missing: "仍缺少一些信息",
  step_alldone: "全部完成",
  yes: "是",
  no: "否",
  music_title: "幻灯片声音",
  music_on: "开启",
  music_off: "关闭",
  music_help: "从音乐库中选择音乐或导入您自己的（MP3 或 MP4，最大 20 MB）。将自动保存。",
  my_music: "我的音乐",
  save_choice: "保存我的选择",
  replace_music: "替换我的音乐",
  import_music: "导入我的音乐",
  delete_music: "删除我的音乐",
  music_file_default: "音乐",
  music_saved: "音乐已保存 ✓",
};

export const postinity3 = { fr, en, es, de, it, pl, fil, ru, el, hi, ja, zh };
